import React from 'react'
import {CSSTransitionGroup} from 'react-transition-group'
import PVHeader from './pvHeader.js'

export default class RenderOutro extends React.Component{
	render(){
		const {
			pvEndData,
			sendData,
			lang
		} = this.props

		const outroData = pvEndData.screen_2
		const headline = outroData.text_1
		let icon = outroData.icon_black
		if(icon){
			icon = outroData.icon_black.filename
		}
		let text = outroData.text_2.do_not_save_data
		let subtext = outroData.text_3
		const iconpath = lang.concat('/PV_End/screen_2/', icon)

		if(sendData){
			text = outroData.text_2.save_data
		}
		return(
			<CSSTransitionGroup
				transitionName="pv-background"
				transitionAppear={true}
				transitionAppearTimeout={1000}
				transitionEnterTimeout={1000}
				transitionLeaveTimeout={1000}>
				<div className='pv pv-outro'>
					<PVHeader
						pvEndData={pvEndData}
						newheadline={headline}
						lang={lang}
					/>
					<div className='text'>{text}</div>
					<div className='subtext'>{subtext}</div>
					<div className ='outroIcon' style={{'backgroundImage': `url(${iconpath})`}}/>
					</div>
			</CSSTransitionGroup>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/presentationReferral/subcomponents/renderOutro.js